import {z} from 'zod';

/**
 * Zod transform that accepts a single string or an array of strings and returns
 * either the first value or undefined. Used for query params that semantically
 * take one value even if Hono's req.queries() returns an array.
 */
export const singleString = z
  .union([z.string(), z.array(z.string())])
  .optional()
  .transform((val) => {
    if (!val) {
      return undefined;
    }
    return Array.isArray(val) ? val[0] : val;
  });
